import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Alert, Spinner, Image, Row, Col, Card } from 'react-bootstrap';
import { LanguageProvider } from '../core/language-provider';
import { LoginManager } from '../core/login-manager';
import { DataManager } from '../core/data-manager';
import PromoSlider from '../components/PromoSlider';
import HomeCorsiNuovi from '../components/Home/HomeCorsiNuovi';
import HomeCorsiSuggeriti from '../components/Home/HomeCorsiSuggeriti';
import HomeCorsiInEvidenza from '../components/Home/HomeCorsiInEvidenza';
import HomeCorsiDaContinuare from '../components/Home/HomeCorsiDaContinuare';
import HomeChiSiamo from '../components//Home/HomeChiSiamo';
import HomeMenu from '../components/Home/HomeMenu';
import HomeCorsi from '../components/Home/HomeCorsi';
import banner from '../assets/home_vela.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HomeEventi from '../components/Home/HomeEventi';
import { ApiManager } from '../core/api-manager';


export default function Home() {

    const userInfo = LoginManager.getUserInfo();
    const [corsiCompletati, setCorsiCompletati] = useState(null);
    const [data, setData] = useState(null);
    const navigate = useNavigate();
    const isMobile = window.innerWidth < 768;


    useEffect(() => {
        getDataHome()
    }, []);

    useEffect(() => {
        getCorsiCompletati();
        getDataHome()
    }, [userInfo])

    async function getCorsiCompletati() {
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var response = await DataManager.getItems('gyv_course_user', 1, 1000, sorting)
        if (response.success === 1) {
            setCorsiCompletati(response.body);
        }
    }

    async function getDataHome() {
        var body = {}
        var response = await ApiManager.sendAuthenticatedRequest('/custom/get_data_home', body);
        if (response.success === 1) {
            setData(response)
        }
    }





    if (userInfo !== null) {
        return (
            <Container fluid className='p-0'>
                <div style={isMobile ? { position: 'relative', backgroundColor: `var(--primary-color)`, height: '100%', paddingTop: '20px', paddingBottom: '50px' } : { position: 'relative', backgroundColor: `var(--primary-color)` }}>
                    <div id="luna_bordo"></div>
                    <div id="luna" style={{ backgroundImage: `url(${banner})` }}></div>

                    <Container fluid style={{ background: 'transparent !important' }}>
                        <Row style={isMobile ? { height: '100%' } : { height: 'calc(100vh - 65px)' }}>
                            <Col md={2}></Col>
                            <Col md={6} xs={12} style={{ zIndex: 1 }}>
                                <Row style={isMobile ? { height: '42%', alignItems: 'center' } : { height: '50%', alignItems: 'end' }}>
                                    <Col xs={12}>
                                        <h1 style={isMobile ? { color: 'white', fontSize: '40px', fontWeight: 900 } : { color: 'white', fontWeight: 900, fontSize: '72px' }}>Fai il carico di conoscenza</h1>
                                        <h5 className='text-white' style={isMobile ? { fontSize: '16px' } : { fontSize: '28px', lineHeight: '1.3' }}>L’offerta formativa e la proposta di seminari,<br /> eventi e pubblicazioni del sistema<br /> associativo di Fedespedi</h5>
                                    </Col>
                                </Row>
                                <Row className='h-50 align-items-center mb-5'>
                                    <Col>
                                        <h4 className='mb-3 text-white' style={isMobile ? { fontSize: '20px' } : { fontSize: '28px', lineHeight: '1.3' }}>Ciao {userInfo.name},</h4>
                                        <Row>
                                            <Col xs={12} md={3} className='mb-3'>
                                                <Card style={{ borderRadius: '20px', backgroundColor: 'var(--secondary-color)', border: 'none' }} className='text-center h-100'>
                                                    <Card.Body>
                                                        <h3 style={{ color: 'var(--primary-color)' }}>{data && data.userCourse.length} / {data && data.totalCourse.length}</h3>
                                                        <h6>Corsi completati</h6>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col xs={12} md={3} className='mb-3'>
                                                <Card style={{ borderRadius: '20px', backgroundColor: 'var(--secondary-color)', border: 'none' }} className='text-center h-100'>
                                                    <Card.Body>
                                                        <h3 style={{ color: 'var(--primary-color)' }}>{data && data.userEvent.length} / {data && data.totalEvent.length}</h3>
                                                        <h6>Seminari partecipati</h6>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col xs={12} md={3} className='mb-3'>
                                                <Card style={{ borderRadius: '20px', backgroundColor: 'var(--secondary-color)', border: 'none' }} className='text-center h-100'>
                                                    <Card.Body>
                                                        <h3 style={{ color: 'var(--primary-color)' }}>{data && data.userConvegno.length} / {data && data.totalConvegno.length}</h3>
                                                        <h6>Convegni partecipati</h6>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col xs={12} md={3} className='mb-3'>
                                                <Card style={{ borderRadius: '20px', backgroundColor: 'var(--secondary-color)', border: 'none' }} className='text-center h-100'>
                                                    <Card.Body>
                                                        <h3 style={{ color: 'var(--primary-color)' }}>{data && data.userPublication.length} / {data && data.totalPublication.length}</h3>
                                                        <h6>Pubblicazioni scaricate</h6>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={4}></Col>
                        </Row>
                    </Container>
                </div>

                <HomeMenu />

                <HomeEventi />

                <HomeChiSiamo />

            </Container>
        )
    }
    else {
        return (
            <Container fluid="md" className='mt-5 mb-5'>
                <div className='text-center p-5'>
                    <Spinner animation="border" variant="primary" />
                    <p className='text-primary'>{LanguageProvider.get('defaults.loading')}</p>
                </div>
            </Container>
        )
    }
};